import { useState, useEffect } from 'react';

const LAUNCH_DATE = new Date('2026-04-30T23:59:59');

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

function getTimeLeft(): TimeLeft {
  const diff = LAUNCH_DATE.getTime() - Date.now();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
}

function Pad(n: number) {
  return String(n).padStart(2, '0');
}

export default function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(getTimeLeft());

  useEffect(() => {
    const id = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    { label: 'Days', value: timeLeft.days },
    { label: 'Hours', value: timeLeft.hours },
    { label: 'Minutes', value: timeLeft.minutes },
    { label: 'Seconds', value: timeLeft.seconds },
  ];

  return (
    <div className="flex flex-col items-center gap-3">
      <p
        className="font-sans text-xs tracking-[0.3em] uppercase"
        style={{ color: 'rgba(212,175,55,0.65)' }}
      >
        Launching in
      </p>
      <div className="flex items-center gap-2 sm:gap-4">
        {units.map((unit, i) => (
          <div key={unit.label} className="flex items-center gap-2 sm:gap-4">
            <div className="flex flex-col items-center">
              <div
                className="relative flex items-center justify-center rounded"
                style={{
                  width: 'clamp(48px, 8vw, 64px)',
                  height: 'clamp(48px, 8vw, 64px)',
                  background: 'linear-gradient(145deg, rgba(61,16,16,0.9), rgba(92,31,31,0.7))',
                  border: '1px solid rgba(212,175,55,0.35)',
                }}
              >
                <span
                  className="font-serif font-bold tabular-nums"
                  style={{
                    fontSize: 'clamp(1.3rem, 4vw, 1.8rem)',
                    color: '#D4AF37',
                    lineHeight: 1,
                  }}
                >
                  {Pad(unit.value)}
                </span>
              </div>
              <span
                className="mt-1.5 font-sans uppercase tracking-widest"
                style={{ color: 'rgba(244,228,193,0.45)', fontSize: '0.55rem' }}
              >
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 && (
              <span
                className="font-serif font-bold mb-4"
                style={{ color: 'rgba(212,175,55,0.5)', fontSize: '1.2rem' }}
              >
                :
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
